<template>
    <div>
        <a-table id="myServiceTable" :columns="columns" :data-source="tableData" :pagination="false" :loading="tloading" rowKey="id">
            <template slot="moduleP" slot-scope="text,record">
                <a-tag v-if="record.mcmsflag == '1'" :color="'green'">
                    <span v-if="record.mcmscustom == 1">消息中心[{{record.mcmscode}}]</span>
                    <span v-else>消息中心</span>
                </a-tag>
                <a-tag v-if="record.umsflag == '1'" :color="'green'">
                    <span v-if="record.umscustom == 1">账号中心[{{record.umscode}}]</span>
                    <span v-else>账号中心</span>
                </a-tag>
                <a-tag v-if="record.fmsflag == '1'" :color="'green'">
                    <span v-if="record.fmscustom == 1">导入导出[{{record.fmscode}}]</span>
                    <span v-else>导入导出</span>
                </a-tag>
                <a-tag v-if="record.configflag == '1'" :color="'green'">
                    <span v-if="record.configcustom == 1">云端配置[{{record.configcode}}]</span>
                    <span v-else>云端配置</span>
                </a-tag>
                <a-tag v-if="record.ossflag == '1'" :color="'green'">
                    <span v-if="record.osscustom == 1">OSS[{{record.osscode}}]</span>
                    <span v-else>OSS</span>
                </a-tag>
            </template>
            <template slot="operation" slot-scope="text, record">
                <router-link class="tableLink" :to="{path:'detail_platformtype',query: {id: record.id,}}">详情</router-link>
                <router-link class="tableLink" :to="{path:'edit_platformtype',query: {id: record.id,}}">编辑</router-link>
                <a-popconfirm v-if="record.delflag == '1'" title="确认删除?" @confirm="() => handleDelete(record)">
                    <a class="tableLink" href="javascript:;">删除</a>
                </a-popconfirm>
            </template>

        </a-table>

        <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

    </div>
</template>
<script>
let pagination = {
    page: 1,
    pageSize: 10,
    total: 0,
}

const columns = [
    {
        title: '平台编码',
        dataIndex: 'platformtype',
        align: 'center',
        width: 120,
    },
    {
        title: '平台名称',
        dataIndex: 'platformtypename',
        align: 'center',
        width: 100,
    },
    {
        title: '关联模块',
        dataIndex: 'module',
        align: 'center',
        scopedSlots: { customRender: 'moduleP' },
        width: 200,
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 150,
        scopedSlots: { customRender: 'operation' },
    },
]

export default {
    data() {
        return {
            columns,
            tableData: [],
            tloading: false,
            pagination,
            clientWidth: 800,
            searchP: {},
        }
    },
    methods: {
        handlePageChange(v) {
            this.pagination.page = v
            this.getAppSumData()
        },
        handleDelete(item) {
            let that = this
            that.$store
                .dispatch({
                    type: 'platformlist/platformDel',
                    params: { id: item.id },
                })
                .then((res) => {
                    if (res.status == '200') {
                        that.pagination.page = 1
                        that.getAppSumData()
                    }
                })
        },
        getAppSumData() {
            let that = this
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams: false,
            }
            that.$store
                .dispatch({
                    type: 'platformlist/queryPlatformPage',
                    params: params,
                })
                .then((res) => {
                    if (res.status == 200 && res.data.success == '1') {
                        let result = res.data.data
                        this.tableData = result.list
                        this.pagination.total = parseInt(result.totalRecords)
                        this.pagination.pageSize = parseInt(result.pageSize)
                        this.pagination.page = parseInt(result.page)
                    }
                    that.tloading = false
                })
                .catch(() => {
                    that.tloading = false
                })
        },
        handleSearch(searchP) {
            this.searchP = searchP
            this.pagination.page = 1
            this.getAppSumData()
        },
    },

    components: {},
    mounted() {},
}
</script>
<style scoped>
.trend_pagination {
    margin-top: 10px;
}

.tableLink {
    margin-right: 10px;
}
</style>

